import {Injectable} from '@angular/core';
import {SnackService} from '../snack/snack.service';
import {TicketControlService as Api} from "../../generated/sales-terminal-client";
import {Observable, tap, map} from 'rxjs';

@Injectable()
export class TicketControlService {
  constructor(private api: Api,
              private snackService: SnackService) {
  }

  public getEventQrCode(id: number): Observable<Blob> {
    return this.api.eventIdTicketControlQrGet(id, 'body', true, {
      httpHeaderAccept: 'image/svg+xml'
    }).pipe(
      tap({error: (e) => this.snackService.showBackendError(e)}),
      map(value => new Blob([value], { type: 'image/svg+xml' }))
    )
  }
}
